import { PRICING_PLANS } from "features/subscriptions/constants";

import type { SubscriptionType } from "common/types";

import SubscriptionPlanIcon from "./SubscriptionPlanIcon";

export default function SubscriptionPlan({ plan }: { plan: SubscriptionType }) {
  const { name, description } = PRICING_PLANS[plan];

  return (
    <div className="flex gap-x-2.5 px-2 mb-4">
      <SubscriptionPlanIcon plan={plan} size="sm" />
      <div className="flex flex-col items-start gap-y-1">
        <h3 className="text-md-bold">{name}</h3>
        <p className="text-xs-medium text-black-500">{description}</p>
      </div>
    </div>
  );
}
